module.exports = __webpack_public_path__ + "static/media/Løpe.59ec3265.PNG";